// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__fIHO2","icons":"Footer_icons__3Vo4c"};